import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuxiliarService } from './../../auxiliar.service';
import { AuthService } from './../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  server: string = '';
  serverURL: string = '';
  token: string = '';

  constructor(private auth: AuthService, private httpClient: HttpClient, private auxiliarService: AuxiliarService) {
    this.server = this.auxiliarService.getServidor()+"/api/administrador/usuarios";
    this.serverURL = this.auxiliarService.getServidor()+"/api";
    this.token = this.auth.getToken();
  }

  getUsuarios(estado: string) {
    return this.httpClient.get(this.server+"/get/"+estado);
  }

  newUsuario(name: string, surname: string, email: string, password: string, active: string = "false", permiso_total: string, permiso_pesar: string,
              permiso_clasificar: string, permiso_registros: string, permiso_registrosDatos: string, permiso_registrosPesos: string, permiso_usuarios: string,
              permiso_contenedores: string, permiso_contenedores_alta_movimientos: string, permiso_contenedores_alta_mantenimientos: string) {
    const formData = new FormData();
    formData.append('name', name);
    formData.append('surname', surname);
    formData.append('email', email);
    formData.append('password', password);
    formData.append('active', active.toString());
    formData.append('permiso_total', permiso_total);
    formData.append('permiso_pesar', permiso_pesar);
    formData.append('permiso_clasificar', permiso_clasificar);
    formData.append('permiso_registros', permiso_registros);
    formData.append('permiso_registrosDatos', permiso_registrosDatos);
    formData.append('permiso_registrosPesos', permiso_registrosPesos);
    formData.append('permiso_usuarios', permiso_usuarios);
    formData.append('permiso_contenedores', permiso_contenedores);
    formData.append('permiso_contenedores_alta_movimientos', permiso_contenedores_alta_movimientos);
    formData.append('permiso_contenedores_alta_mantenimientos', permiso_contenedores_alta_mantenimientos);
    return this.httpClient.post(this.server, formData);
  }

  deleteUsuario(id: number){
    return this.httpClient.delete(this.server+"/"+id);
  }

  editUsuarioAdmin(id: number, name: string, surname: string, email: string, active: string = "false", permiso_total: string, permiso_pesar: string,
              permiso_clasificar: string, permiso_registros: string, permiso_registrosDatos: string, permiso_registrosPesos: string, permiso_usuarios: string, 
              permiso_contenedores: string, permiso_contenedores_alta_movimientos: string, permiso_contenedores_alta_mantenimientos: string,
              scaleIds: number[] = []) {
    const formData = new FormData();
    formData.append('id', id.toString());
    formData.append('name', name);
    formData.append('surname', surname);
    formData.append('email', email);
    formData.append('active', active);
    formData.append('permiso_total', permiso_total);
    formData.append('permiso_pesar', permiso_pesar);
    formData.append('permiso_clasificar', permiso_clasificar);
    formData.append('permiso_registros', permiso_registros);
    formData.append('permiso_registrosDatos', permiso_registrosDatos);
    formData.append('permiso_registrosPesos', permiso_registrosPesos);
    formData.append('permiso_usuarios', permiso_usuarios);
    formData.append('permiso_contenedores', permiso_contenedores);
    formData.append('permiso_contenedores_alta_movimientos', permiso_contenedores_alta_movimientos);
    formData.append('permiso_contenedores_alta_mantenimientos', permiso_contenedores_alta_mantenimientos);
    formData.append('scale_ids', JSON.stringify(scaleIds || []));
    return this.httpClient.post(this.server+"/update", formData);
  }

  getUsuarioScales(id: number) {
    return this.httpClient.get(this.server + "/scales/" + id);
  }

  editUsuarioProfile(id: number, name: string, surname: string, email: string){
    const formData = new FormData();
    formData.append('id', id.toString());
    formData.append('name', name);
    formData.append('surname', surname);
    formData.append('email', email);
    return this.httpClient.post(this.serverURL+"/user/update/profile", formData);
  }

  editUsuarioPassword(id: number, password: string){
    const formData = new FormData();
    formData.append('id', id.toString());
    formData.append('password', password);
    return this.httpClient.post(this.serverURL+"/user/update/password", formData);
  }

}
